export default __webpack_public_path__ + "static/media/launchAddState.41d77507.png";